import { SORT_DIRECTION_SEPARATOR, SORT_TOKEN_SEPARATOR, SortDirectionEnum } from './sort-consts';

export type SortRule = { id: string; desc?: boolean };

const SORT_DIRECTIONS = new Set<string>(Object.values(SortDirectionEnum));

export const normalizeSortRules = <TRule extends SortRule>(
	rules: TRule[] = [],
	allowedIds: ReadonlySet<string>
): TRule[] => {
	const seen = new Set<string>();
	const normalized: TRule[] = [];

	for (const rule of rules) {
		if (!allowedIds.has(rule.id) || seen.has(rule.id)) {
			continue;
		}

		seen.add(rule.id);
		normalized.push({ ...rule, desc: Boolean(rule.desc) });
	}

	return normalized;
};

const sortRuleToToken = ({ id, desc }: SortRule): string => {
	const direction = desc ? SortDirectionEnum.DESC : SortDirectionEnum.ASC;

	return `${id}${SORT_DIRECTION_SEPARATOR}${direction}`;
};

export const stringifySortRules = (rules: SortRule[]): string => rules.map(sortRuleToToken).join(SORT_TOKEN_SEPARATOR);

export const parseSortRules = (raw: string | null | undefined, allowedIds: ReadonlySet<string>): SortRule[] => {
	if (!raw) {
		return [];
	}

	const rules: SortRule[] = [];

	for (const token of raw.split(SORT_TOKEN_SEPARATOR)) {
		const [id, direction] = token.split(SORT_DIRECTION_SEPARATOR);

		if (!SORT_DIRECTIONS.has(direction)) {
			continue;
		}

		rules.push({ id, desc: direction === SortDirectionEnum.DESC });
	}

	return normalizeSortRules(rules, allowedIds);
};
